import styled from "styled-components";

export const Container = styled.div`
  position: relative;

  .gm-style-iw-chr {
    display: none;
  }

  .gm-style-iw-d {
    padding: 12px 12px 12px 0px;
    overflow: unset !important;
  }
`;

export const Map = styled.div`
  width: 100%;
  height: calc(100vh - 64px);
`;

export const ContainerModal = styled.div`
  width: 100%;
  height: calc(100vh - 64px);
`;

export const ContainerButton = styled.button`
  width: 36px;
  border-radius: 8px 0 0 8px;
  height: 120px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  cursor: pointer;
  background: #ffffff;
`;

export const Content = styled.div`
  padding: 16px;
  height: calc(100vh - 67px);
`;

export const ContainerTab = styled.div``;

export const ContainerDriver = styled.div`
  background: rgba(0, 0, 0, 0.12);
  padding: 8px;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
`;

export const SelectDriver = styled.div`
  background: #ffffff;
  height: 62px;
  display: flex;
  padding: 0 10px;
  width: 100%;
  justify-content: space-between;
  margin-top: 8px;
`;

export const Button = styled.button`
  background: none;
  border: 0;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
`;

export const ContainerDriverSelected = styled.div`
  display: flex;
  width: 160px;
  align-items: center;
  gap: 10px;
`;

export const ContainerText = styled.div`
  display: flex;
  margin-top: -3px;
  flex-direction: column;
  h6 {
    display: flex;
    white-space: nowrap;
  }
`;

export const ButtonAccept = styled.button`
  display: flex;
  background: none;
  justify-content: center;
  align-items: center;
  width: auto;
  padding: 8px 24px;
  height: 30px;
  border-radius: 15px;
  border: solid 1px rgba(0, 0, 0, 05);
  cursor: pointer;
`;

export const ButtonBackDrive = styled.button`
  display: flex;
  background: none;
  justify-content: center;
  align-items: center;
  width: auto;
  padding: 8px 24px;
  height: 30px;
  border-radius: 15px;
  border: solid 1px rgba(0, 0, 0, 05);
  cursor: pointer;
`;

export const ButtonApplyDrive = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: auto;
  padding: 8px 24px;
  background: #d33100;
  height: 30px;
  border-radius: 15px;
  border: solid 1px #d33100;
  cursor: pointer;
  color: #ffffff;
`;

export const ContainerButtonsDrive = styled.div`
  display: flex;
  gap: 10px;
`;

export const ContainerAutoComplete = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const ContainerCards = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 16px;
  padding: 8px 0;
  height: -webkit-fill-available;
  background: rgba(0, 0, 0, 0.04);
  overflow-y: auto;
  gap: 8px;
`;

export const ContainerOrdersInfo = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin-top: 8px;
  gap: 8px;

  > div:last-child {
    border-bottom-right-radius: 8px;
  }

  > div:not(:last-child) {
    border-bottom-left-radius: 8px;
  }
`;

export const OrdersInfo = styled.div`
  background: #ffffff;
  height: 52px;
  display: flex;
  padding: 0 10px;
  width: 100%;
  align-items: center;
  justify-content: space-around;
`;

export const InfoWindowContainer = styled.div``;

export const TopInfoWindowContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 15px;
`;

export const LastUpdateText = styled.div``;

export const DriverName = styled.div`
  font-weight: bold;
  margin-right: 5px;
`;

export const OnlineBadge = styled.div`
  border: 1px solid #1b5e20;
  padding: 3px 8px;
  border-radius: 25px;
  color: #1b5e20;
`;
